import React, { useState, useEffect } from "react";
import { Upload, FileSpreadsheet, Database, AlertCircle } from "lucide-react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


// ---------- REPLACEMENT FOR jwt-decode PACKAGE ----------
function jwtDecode(token) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(
      decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      )
    );
  } catch (e) {
    console.error("Invalid JWT:", e);
    return null;
  }
}
// ----------------------------------------------------------

const Assemblies = () => {
  const [userRole, setUserRole] = useState("");
  const [userName, setUserName] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [pendingUpload, setPendingUpload] = useState(null);
  const apiUrl = import.meta.env.VITE_API_URL;
  // const token = localStorage.getItem("token");

  // useEffect(() => {
  //   if (token) {
  //     const decoded = jwtDecode(token);
  //     if (decoded) {
  //       const role = decoded.role || "user";
  //       setUserRole(role.toLowerCase());
  //       setUserName(role); // Use role as the display name
  //     }
  //   }
  // }, [token]);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        
        const res = await fetch(`${apiUrl}/api/auth/me`, {
          credentials: "include",
        });
  
        if (!res.ok) return;
  
        const data = await res.json();
  
        setUserRole(data.role?.toLowerCase() || "user");
        setUserName(data.role);
  
      } catch (err) {
        console.error(err);
      }
    };
  
    fetchUser();
  }, []);

  const fetchUploads = async () => {
    try {
      const res = await fetch(`${apiUrl}/api/boq/uploads`, {
        // headers: { Authorization: `Bearer ${token}` },
        credentials: "include", 
      });
      const data = await res.json();
      if (res.ok) setUploadedFiles(data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchProjects = async () => {
    try {
      const res = await fetch(`${apiUrl}/api/projects`, {
        credentials: "include", 
        // headers: {
        //   Authorization: `Bearer ${token}`,
        // },
      });

      const data = await res.json();

   
      if (res.ok) {
        setProjects(data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const validateProjectUpload = (file, selectedProject) => {
    if (!file) {
      toast.error("Please select a BOQ file");
      return false;
    }

    if (!selectedProject) {
      toast.error("Please select a project");
      return false;
    }

    return true;
  };

  const checkDuplicate = (file, type, selectedProject) => {
    const fileName = file.name;
    
    if (type === "master") {
      return uploadedFiles.some(f => f.type === "master" && f.filename === fileName);
    } else {
      return uploadedFiles.some(f => 
        f.type === "project" && 
        f.filename === fileName && 
        f.project_id === selectedProject
      );
    }
  };

  const confirmReplace = () => {
    setShowConfirmDialog(false);
    if (pendingUpload) {
      performUpload(pendingUpload.file, pendingUpload.type, pendingUpload.selectedProject, true);
    }
    setPendingUpload(null);
  };

  const cancelReplace = () => {
    setShowConfirmDialog(false);
    setPendingUpload(null);
  };

  useEffect(() => {
    fetchUploads();
    fetchProjects();
  }, []);


  const handleUpload = async (file, type, selectedProject) => {
    if (type === "project") {
      const isValid = validateProjectUpload(file, selectedProject);
      if (!isValid) return;
    }

    if (type === "master" && !file) {
      return toast.error("Select a file first!");
    }

    // Check for duplicates
    const isDuplicate = checkDuplicate(file, type, selectedProject);
    
    if (isDuplicate) {
      setPendingUpload({ file, type, selectedProject });
      setShowConfirmDialog(true);
      return;
    }

    performUpload(file, type, selectedProject, false);
  };

  const performUpload = async (file, type, selectedProject, replace = false) => {
    const pyApiUrl = import.meta.env.VITE_PYTHON_API_URL;
    
    const formData = new FormData();
    formData.append("file", file);
    formData.append("project_name", selectedProject);
    formData.append("uploaded_by", userName);
    if (replace) formData.append("replace", "true");

    try {
      setIsLoading(true);

      const endpoint =
        type === "master"
          ? `${apiUrl}/api/boq/upload-master`
          : `${pyApiUrl}/boq/upload-project`;

      const res = await fetch(endpoint, {
        method: "POST",
        credentials: "include", 
        // headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      const data = await res.json();
      console.log("API Response:", data); // Debug log

      if (data.status === "file_exists") {
        // Handle file exists from Python API
        setPendingUpload({ file, type, selectedProject });
        setShowConfirmDialog(true);
      } else if (res.ok && data.status === "success") {
        toast.success(
          `${type === "master" ? "Master" : "Project"} BOQ ${replace ? "replaced" : "uploaded"} successfully`
        );
        fetchUploads();
      } else {
        toast.error(data.message || "Upload failed");
      }
    } catch (err) {
      console.error(err);
      toast.error("Server error during upload");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="max-w-7xl mx-auto p-6">
      <ToastContainer theme="dark" position="top-right" />
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-white mb-2">BOQ Management</h1>
        <p className="text-gray-400">
          Manage master and project BOQs with AI parsing and classification
        </p>
      </div>


      
         <div className="mb-8 px-5 py-5 rounded-2xl border border-yellow-500/50 bg-yellow-500/15">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xl font-bold text-yellow-300 flex items-center gap-4">
            <AlertCircle className="w-7 h-7" />
            BOQ files must include
            <span className="underline decoration-2">Unit and Quantity columns</span>
            for processing.
          </p>
      
          <a
            href="/sample_docs/Project_BOQ_Template 1.xlsx"
            download
            className="inline-flex items-center justify-center px-5 py-3 text-base font-semibold rounded-xl
                       bg-gradient-to-r from-cyan-500 to-blue-600 text-white
                       hover:from-cyan-600 hover:to-blue-700 shadow-lg shadow-cyan-500/30"
          >
            Download Sample BOQ
          </a>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mb-8">
        {userRole === "admin" && (
          <UploadCard
            title="Upload Master BOQ"
            description="Upload classification hierarchy (A–Z)"
            type="master"
            icon={<Database className="text-blue-400 w-8 h-8" />}
            onUpload={handleUpload}
            isLoading={isLoading}
          />
        )}

      


        <UploadCard
          title="Upload Project BOQ"
          description="Upload project-specific cost sheets"
          type="project"
          icon={<FileSpreadsheet className="text-cyan-400 w-8 h-8" />}
          onUpload={handleUpload}
          isLoading={isLoading}
          projects={projects}
          selectedProject={selectedProject}
          setSelectedProject={setSelectedProject}
        />
      </div>

      <div className="bg-gray-800/60 backdrop-blur-sm rounded-2xl shadow-xl border border-gray-700/50 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-900/70 text-gray-300">
            <tr>
              <th className="px-6 py-4 text-left">Type</th>
              <th className="px-6 py-4 text-left">File</th>
              <th className="px-6 py-4 text-left">Uploaded By</th>
              <th className="px-6 py-4 text-left">Date</th>
            </tr>
          </thead>
          <tbody>
            {uploadedFiles.length === 0 ? (
              <tr>
                <td
                  colSpan={4}
                  className="py-12 text-center text-gray-500 flex flex-col items-center"
                >
                  <AlertCircle className="w-10 h-10 mb-3 text-gray-500" />
                  <p>No BOQ files uploaded yet.</p>
                </td>
              </tr>
            ) : (
              uploadedFiles.map((file, idx) => (
                <tr
                  key={idx}
                  className="border-b border-gray-700/30 hover:bg-gray-700/20 transition-all duration-300"
                >
                  <td className="px-6 py-3 text-gray-200 capitalize">
                    {file.type}
                  </td>
                  <td className="px-6 py-3 text-white">{file.filename}</td>
                  <td className="px-6 py-3 text-gray-400">
                    {file.uploaded_by || userName}
                  </td>
                  <td className="px-6 py-3 text-gray-400">
                    {new Date(file.uploaded_at).toLocaleString()}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Confirmation Dialog */}
      {showConfirmDialog && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-gray-800 rounded-2xl p-6 max-w-md mx-4 border border-gray-700">
            <div className="flex items-center mb-4">
              <AlertCircle className="w-6 h-6 text-yellow-400 mr-3" />
              <h3 className="text-lg font-semibold text-white">File Already Exists</h3>
            </div>
            <p className="text-gray-300 mb-6">
              A BOQ file with this name already exists. Do you want to replace it?
            </p>
            <div className="flex gap-3">
              <button
                onClick={confirmReplace}
                className="flex-1 bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded-lg font-medium transition-colors"
              >
                Yes, Replace
              </button>
              <button
                onClick={cancelReplace}
                className="flex-1 bg-gray-600 hover:bg-gray-700 text-white py-2 px-4 rounded-lg font-medium transition-colors"
              >
                No, Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const UploadCard = ({
  title,
  description,
  type,
  icon,
  onUpload,
  isLoading,
  projects = [],
  selectedProject,
  setSelectedProject,
}) => {
  const [file, setFile] = useState(null);

  return (
    <div className="bg-gray-800/60 backdrop-blur-sm rounded-2xl border border-gray-700/50 p-6 hover:border-cyan-500/30 transition-all duration-300">
      <div className="flex items-center space-x-4 mb-4">
        <div className="p-3 bg-gray-900/50 rounded-xl">{icon}</div>
        <div>
          <h3 className="text-lg font-semibold text-white">{title}</h3>
          <p className="text-gray-400 text-sm">{description}</p>
        </div>
      </div>

      {/* 🔽 PROJECT DROPDOWN (ONLY FOR PROJECT BOQ) */}
      {type === "project" && (
        <div className="mb-4">
          <label className="block text-sm text-gray-400 mb-2">
            Select Project
          </label>

          <select
            value={selectedProject}
            onChange={(e) => setSelectedProject(e.target.value)}
            className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-cyan-500"
          >
            {projects.length === 0 ? (
              <option value="">No project found</option>
            ) : (
              <>
                <option value="">-- Select Project --</option>
                {projects.map((project) => (
                  <option key={project._id} value={project._id}>
                    {project.project_name}
                  </option>
                ))}
              </>
            )}
          </select>
        </div>
      )}

      {/* 📂 FILE INPUT */}
      <input
        type="file"
        accept=".xlsx,.csv"
        onChange={(e) => setFile(e.target.files[0])}
        className="block w-full text-sm text-gray-300 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-cyan-500/20 file:text-cyan-300 hover:file:bg-cyan-600/30 cursor-pointer"
      />

      <button
        onClick={() => onUpload(file, type, selectedProject)}
        disabled={
          !file ||
          isLoading ||
          (type === "project" && !selectedProject)
        }
        className="mt-4 w-full bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white py-2.5 rounded-lg font-medium shadow-lg shadow-cyan-500/20 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isLoading ? "Uploading..." : "Upload"}
      </button>
    </div>
  );
};


export default Assemblies;
